/**
 * Modelos 3D Sketchfab para o modal de acessórios (gerado automaticamente).
 * Fonte: images/Animations/*.html — executar: node scripts/generate-weapon-animations.cjs
 */
export const WEAPON_SKETCHFAB_EMBEDS = {
    "AK": {
        modelId: "1569b10113324656854dd5f8a4efa106",
        title: "Rust AK Remastered",
        animationFile: "ak.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/rust-ak-remastered-1569b10113324656854dd5f8a4efa106?utm_medium=embed&utm_campaign=share-popup&utm_content=1569b10113324656854dd5f8a4efa106",
            author: "statusqu0",
            authorUrl: "https://sketchfab.com/statusqu0",
        },
    },
    "BOLT": {
        modelId: "b4acae37ae024440b17c0be1076628b8",
        title: "Bolt-Action Rust",
        animationFile: "bolt.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/bolt-action-rust-b4acae37ae024440b17c0be1076628b8?utm_medium=embed&utm_campaign=share-popup&utm_content=b4acae37ae024440b17c0be1076628b8",
            author: "bluepittbull.kiki",
            authorUrl: "https://sketchfab.com/bluepittbull.kiki",
        },
    },
    "Flame_Thrower": {
        modelId: "864273d2df544caa874bbde9d8611718",
        title: "Milkor MLG - Rust",
        animationFile: "lança.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/milkor-mlg-rust-864273d2df544caa874bbde9d8611718?utm_medium=embed&utm_campaign=share-popup&utm_content=864273d2df544caa874bbde9d8611718",
            author: "ThomasButters",
            authorUrl: "https://sketchfab.com/ThomasButters",
        },
    },
    "Grenade_Launcher": {
        modelId: "d70d769b28884824a55a8d2e71d19014",
        title: "Relentless",
        animationFile: "launcher.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/relentless-d70d769b28884824a55a8d2e71d19014?utm_medium=embed&utm_campaign=share-popup&utm_content=d70d769b28884824a55a8d2e71d19014",
            author: "alicankenar",
            authorUrl: "https://sketchfab.com/alicankenar",
        },
    },
    "L96": {
        modelId: "47a2d91400184157b6b1e99217c1e9e0",
        title: "L96",
        animationFile: "l96.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/l96-47a2d91400184157b6b1e99217c1e9e0?utm_medium=embed&utm_campaign=share-popup&utm_content=47a2d91400184157b6b1e99217c1e9e0",
            author: "AAD_",
            authorUrl: "https://sketchfab.com/aad_",
        },
    },
    "LR": {
        modelId: "ac375d2498bd4a59a23a878312b6ac43",
        title: "LR-300 ML-A Assault Rifle",
        animationFile: "lr.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/lr-300-ml-a-assault-rifle-ac375d2498bd4a59a23a878312b6ac43?utm_medium=embed&utm_campaign=share-popup&utm_content=ac375d2498bd4a59a23a878312b6ac43",
            author: "Icaro Arrigoni",
            authorUrl: "https://sketchfab.com/IcaroArrigoni",
        },
    },
    "M249": {
        modelId: "0f7227825ddc4c67b20cee3987ba924f",
        title: "Spider M249",
        animationFile: "m249.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/spider-m249-0f7227825ddc4c67b20cee3987ba924f?utm_medium=embed&utm_campaign=share-popup&utm_content=0f7227825ddc4c67b20cee3987ba924f",
            author: "SendoX",
            authorUrl: "https://sketchfab.com/SendoX",
        },
    },
    "M39_Rifle": {
        modelId: "a5c37e5edf4c43c989429cc4a36bca07",
        title: "TACTICAL UNIT | M39",
        animationFile: "m39.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/tactical-unit-m39-a5c37e5edf4c43c989429cc4a36bca07?utm_medium=embed&utm_campaign=share-popup&utm_content=a5c37e5edf4c43c989429cc4a36bca07",
            author: "L1stic",
            authorUrl: "https://sketchfab.com/L1stic",
        },
    },
    "MP5": {
        modelId: "c5e43bab0ee2472294e9151f8ff43d54",
        title: "MP5 (Free)",
        animationFile: "mp5.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/mp5-free-c5e43bab0ee2472294e9151f8ff43d54?utm_medium=embed&utm_campaign=share-popup&utm_content=c5e43bab0ee2472294e9151f8ff43d54",
            author: "Skabl",
            authorUrl: "https://sketchfab.com/skabl_yt",
        },
    },
    "SEMI": {
        modelId: "9fde5240f21d4bbea34e156389aa2bd2",
        title: "Semi Auto Rifle - Rust (LowPoly)",
        animationFile: "sar.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/semi-auto-rifle-rust-lowpoly-9fde5240f21d4bbea34e156389aa2bd2?utm_medium=embed&utm_campaign=share-popup&utm_content=9fde5240f21d4bbea34e156389aa2bd2",
            author: "somioo00213",
            authorUrl: "https://sketchfab.com/dororolft",
        },
    },
    "SPAS": {
        modelId: "52e8677463194937a50667fc73714525",
        title: "Spas-12",
        animationFile: "spas.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/spas-12-52e8677463194937a50667fc73714525?utm_medium=embed&utm_campaign=share-popup&utm_content=52e8677463194937a50667fc73714525",
            author: "Hatori",
            authorUrl: "https://sketchfab.com/thund3r1331",
        },
    },
    "THOMPSON": {
        modelId: "133fde9927c54b509642d98aafc1a3a4",
        title: "Guerilla Thompson",
        animationFile: "thompson.html",
        credit: {
            modelUrl: "https://sketchfab.com/3d-models/guerilla-thompson-133fde9927c54b509642d98aafc1a3a4?utm_medium=embed&utm_campaign=share-popup&utm_content=133fde9927c54b509642d98aafc1a3a4",
            author: "ravvick",
            authorUrl: "https://sketchfab.com/ravvick",
        },
    },
};

/** @param {string | null | undefined} weaponKey */
export function getWeaponSketchfabEmbed(weaponKey) {
    if (!weaponKey) return null;
    return WEAPON_SKETCHFAB_EMBEDS[weaponKey] ?? null;
}

/**
 * URL do iframe embed Sketchfab.
 * @param {string} modelId
 * @param {{ autostart?: boolean }} [opts]
 */
export function sketchfabEmbedUrl(modelId, { autostart = true } = {}) {
    const params = new URLSearchParams();
    if (autostart) params.set("autostart", "1");
    params.set("ui_theme", "dark");
    params.set("ui_infos", "0");
    params.set("ui_watermark", "0");
    params.set("ui_controls", "1");
    params.set("scrollwheel", "1");
    const q = params.toString();
    return `https://sketchfab.com/models/${modelId}/embed${q ? `?${q}` : ""}`;
}
